import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes from "model";
import { useEffect } from "react";
import EDEDeliveryOptionsPage from "components/EDEStatements/pages/EdeEditUserSettingsPage/components/EDEDeliveryOptionsPage";
import EdeEditUserSettingsPage, { getDefaultPageData, getDefaultPageUI } from "components/EDEStatements/pages/EdeEditUserSettingsPage";
import Util from "classes/Util";

/**
 * @function CaptureMabiEDEStatementsMyAccounts
 * @param {OBJECT} props - None used for now.
 * @description - Component for capture "007_My_Accounts" in mabi23 capture group "Statements".
 */
export default function CaptureMabiEDEStatementsMyAccounts(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "content" ], EDEDeliveryOptionsPage)
    .update([ "deliveryOptions" ], { isActive: true })
    .update([ "email" ], { isActive: false })
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    }, []);

    return <EdeEditUserSettingsPage ui={ ui }  />
}